import styled from "styled-components";
export const TeacherProfileContainer = styled.div`
  flex: 1;
`;

export const TeacherProfileContent = styled.div`
  margin-top: 16px;
  display: flex;
  .firstChild {
    display: flex;
    flex-direction: column;
  }
  .secondChild {
    flex: 1;
    padding-left: 100px;
  }
  .flx {
    display: flex;

    justify-content: center;
  }
`;
export const TeacherPageContainer = styled.div``;

export const TeacherPageContent = styled.div``;

export const AssignedSubject = styled.div`
  display: inline-block;
  padding: 1px 6px;
  border-radius: 10px;
  margin-right: 6px;
  margin-bottom: 6px;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  &:hover {
    background: orangered;
    opacity: 0.6;
    color: #fff;
    border: 1px solid orangered;
  }
 
`;
